const MIXPANEL_TOKEN = {
  PRODUCTION: {
    token: "5e3e0dfa35e3ed0a1373b8923d5c3cd9",
    token_v2: "d5d6c6e0f0be52e730142017d379d5c3"
  },
  DEVELOPMENT: {
    token: "9bce89b4a89e25618465f9f5396bb240",
    token_v2: "4b1ca8868c7943d2ae47cbb6a93bfeb1"
  },
  TEST: {
    token: "e7f09afa94602313d994bf0a2158402b", //To be removed. This is v2 token for preprod
    token_v2: "e7f09afa94602313d994bf0a2158402b"
  }
};
export const DEFAULT_APP_VERSION = "1.0.0";
export default MIXPANEL_TOKEN;
